/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import {
  type ContextValue,
  Table as TableCore,
  type TableProps as TableCoreProps,
  UNSTABLE_ToastQueue,
  useContextProps,
} from 'react-aria-components';
import type { TableSelectionSnackbarProps } from '../table-selection-snackbar/table-selection-snackbar.component';

interface TableProps extends Omit<TableCoreProps, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const TableContext = createContext<ContextValue<TableProps, HTMLDivElement>>({});

const tableSelectionToastQueue = new UNSTABLE_ToastQueue<TableSelectionSnackbarProps>();

const Table = forwardRef((props: TableProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TableContext);

  const { style, children, onSelectionChange, ...coreProps } = props;

  return (
    <TableCore
      ref={ref}
      onSelectionChange={(keys) => {
        onSelectionChange?.(keys);
        tableSelectionToastQueue.clear();
        if (keys !== 'all' && keys.size === 0) {
          return;
        }

        tableSelectionToastQueue.add({
          selectedRowsCount: keys === 'all' ? keys : keys.size,
          onClearSelection: () => {
            onSelectionChange?.(new Set());
            tableSelectionToastQueue.clear();
          },
        });
      }}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {children}
    </TableCore>
  );
});

const styles = stylex.create({
  base: {
    borderSpacing: 0,
  },
});

export { Table, TableContext, tableSelectionToastQueue, type TableProps };
